import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { CopyFormArgument, staffFormArgument, dateArgument } from '@/models/ec-setting'

const SYNCHRO_URL = '/rest/es/crmuser/synchro'
const CUSTOMER_ITEM_URL = '/rest/es/dailyarrange/itemList'
const DATA_EXISTS_URL = '/rest/es/dailyarrange/getDateExists'
const DATA_ARRANGE_URL = '/rest/es/dailyarrange/{date}/{itemId}'
const GET_STAFF_URL = '/rest/es/crmuser/list/{itemId}/{date}'
const COPY_LIST_URL = '/rest/es/dailyarrange/copyList'
const SAVE_LIST_URL = '/rest/es/dailyarrange'
const DEL_LIST_URL = '/rest/es/dailyarrange/{date}/{itemId}'
const ADD_STAFF_URL = '/rest/es/dailyarrange/insertCrmUser'
const GROUP_LIST_URL = '/rest/es/acceptgroup/listByWyCustomerId'
const SAVE_GROUP_URL = '/rest/es/acceptgroup/saveList' // 保存接收小组列表
const SAVE_FILE_URL = '/rest/es/dailyarrange/files' // 导入人员
const SAVE_RENAME_URL = '/rest/es/dailyarrange/submitRepeat' // 提交重复人员

export default {
  synchro ({crmCode}, cb) {
    http.get(SYNCHRO_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getGroupList (cb) {
    http.get(GROUP_LIST_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getItem (cb) {
    http.get(CUSTOMER_ITEM_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getExists (form, cb) {
    http.get(DATA_EXISTS_URL, {
      params: convert.toJson(form, dateArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  dateArrange ({crmCode}, date, itemId, cb) {
    const url = DATA_ARRANGE_URL.replace('{itemId}', itemId)
    http.get(url.replace('{date}', date), {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getStaffList ({crmCode}, date, itemId, cb) {
    const url = GET_STAFF_URL.replace('{itemId}', itemId)
    http.get(url.replace('{date}', date), {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  copyList (form, cb) {
    let postData = convert.toStringify(form, CopyFormArgument)
    http.post(COPY_LIST_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveAddGroup (form, cb) {
    http.post(SAVE_GROUP_URL, form, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveReName (form, cb) {
    http.post(SAVE_RENAME_URL, form, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveFiles (form, cb) {
    let formData = new FormData()
    formData.append('date', form.date)
    formData.append('itemId', form.itemId)
    formData.append('file', form.file)
    formData.append('crmCode', form.crmCode)
    http.post(SAVE_FILE_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  addStaff (form, cb) {
    let postData = convert.toStringify(form, staffFormArgument)
    http.post(ADD_STAFF_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  savelist (form, cb) {
    // let postData = convert.toJson(form, saveFormArgument)
    http.post(SAVE_LIST_URL, form, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  dellist ({crmCode}, date, itemId, cb) {
    const url = DEL_LIST_URL.replace('{itemId}', itemId)
    http.delete(url.replace('{date}', date), {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/data-dispose.js